var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { attrs: { id: "app" } },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center", attrs: { id: "loading" } },
            [_c("b-spinner", { attrs: { label: "Spinning" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("app-header", { attrs: { title: _vm.title } }),
      _vm._v(" "),
      _c(
        "v-content",
        [
          _c("router-view", {
            staticClass: "main-contents",
            on: { "title-change": _vm.titleChange }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 7HvE
// module chunks = 1